export default __webpack_public_path__ + "assets/front/scss/user-authentication.670a2bebb341c6b91a327ea9621d8b70.css";